// react
import React from 'react';

export default function AccountTimeout() {
    return (
        <span />
    );
}
